/**
 * Remove all childs from a node
 */
export const empty = ($el) => {
  while ($el.firstChild) $el.removeChild($el.firstChild);
}

/**
 * Get node boundings
 */
export const rect = ($el) => {
  return $el.getBoundingClientRect();
}

export default { empty, rect };
